import React from 'react'
import ApplicationContext from '../../context'

export const GetFullName = person => {
	const fName = person && person.FirstName ? person.FirstName : '';
	const lName = person && person.LastName ? person.LastName : '';
	return (fName + " " + lName).replace(/(\r\n|\n|\r)/gm, " ");
}

export const getContrastYIQ = (hexcolor) => {
	if (hexcolor) {
		hexcolor = hexcolor.replace("#", "")
		var r = parseInt(hexcolor.substr(0, 2), 16)
		var g = parseInt(hexcolor.substr(2, 2), 16)
		var b = parseInt(hexcolor.substr(4, 2), 16)
		var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000
		return (yiq >= 128) ? 'black' : 'white'
	} else {
		return 'black'
	}
}

export const getBase64 = (file) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onloadend = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});

export const checkEmailValid = (emailStr) => {
	if (!emailStr) return true;
	var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
	if (!emailStr.match(validRegex)) {
		return false;
	}
	return true;
}

export const useLoader = () => {
	const { setState } = React.useContext(ApplicationContext)
	return show => {
		setState(prev => {
			const val = show ? prev.counter + 1 : Math.max(0, prev.counter - 1)
			if (window.optima && window.optima.UI) {
				if (val > 0) {
					window.optima.UI.loader.show()
				} else {
					window.optima.UI.loader.hide()
				}
			}
			return {
				...prev,
				loader: val > 0,
				counter: val
			}
		})
	}
}

export const currencyFormat = (currencyID, Currencies) => {
	return currencyID
		? {
			format: '%v%s',
			symbol: Currencies[currencyID].symbol,
			locale: document.documentElement.lang || 'he-IL'
		}
		: {
			format: '%v%s',
			symbol: '',
			locale: document.documentElement.lang || 'he-IL'
		};
};